// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__33uTu","imageUploader":"EGiftCard_imageUploader__vg0MV"};